<template>
    <el-dialog title="申请信息" :visible.sync="detailsShow" :close-on-click-modal="false" width="500" ref="dialog"
        @close="close" top="5vh">
        <div style="margin: 0px;" >
            <el-form :inline="true" label-width="140px" label-position="left" v-loading="loading">
                <el-row>
                    <!-- <el-col>
                        <div class="tk-head-flex" style="margin-top: 10px;">
                            <h3 class="tk-head-title">申请信息</h3>
                        </div>
                    </el-col> -->
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="企微申请编号：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ComWxSpNo ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="工单Id：" size="medium" class="item-width">
                            <div class="content-color">{{ info.JobId ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="工单标题：" size="medium" class="item-width">
                            <div class="content-color">{{ info.JobTitle ||'--'}}</div>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :lg="12">
                        <el-form-item label="客户名称：" size="medium" class="item-width">
                            <div class="content-color">{{ info.CustomerName ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="上游付款情况说明：" size="medium" class="item-width">
                            <div class="content-color">{{ info.DownPayRemark ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="垫资金额：" size="medium" class="item-width">
                            <div class="content-color">{{ info.AdvanceFundsAmount ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="上游实际结算金额：" size="medium" class="item-width">
                            <div class="content-color">{{ info.UpPayAmount ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="下游实际结算金额：" size="medium" class="item-width">
                            <div class="content-color">{{ info.DownPayAmount ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="付款公司：" size="medium" class="item-width">
                            <div class="content-color">{{ info.PayCompany ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="付款日期：" size="medium" class="item-width">
                            <div class="content-color">{{ info.PayDateTime ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="收款人：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ReceiveUserName ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="收款银行账号：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ReceiveBankAccount ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="收款公司：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ReceiveBankName ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="企微申请人：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ComWxApplyUser ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="企微申请状态：" size="medium" class="item-width">
                            <div class="content-color" v-if="info.ComWxAuditStatus==2" style="color: blue;">{{ info.ComWxAuditStatusName ||'--'}}</div>
                            <div class="content-color" v-else-if="info.ComWxAuditStatus==1" style="color: red;">{{ info.ComWxAuditStatusName ||'--'}}</div>
                            <div class="content-color" v-else >{{ info.ComWxAuditStatusName ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="企微申请时间：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ComWxApplyTime ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="企微申请备注：" size="medium" class="item-width">
                            <div class="content-color">{{ info.ComWxAuditRemark ||'--'}}</div>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :lg="12">
                        <el-form-item label="创建时间：" size="medium" class="item-width">
                            <div class="content-color">{{ info.CreateTime ||'--'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                        <el-form-item label="企微申请附件：" size="medium" class="item-width">
                            <!-- <img v-if="info.FileUrl" :src="info.FileUrl" alt="" width="400">
                            <span v-else>--</span> -->

                               <el-link v-if="info.FileUrl"  :href="info.FileUrl" target="_blank" :key="info.FileUrl" class="img-item">
                                    <el-image :src="info.FileUrl" fit="cover" :key="info.FileUrl">
                                    </el-image>
                               </el-link>
                               <span v-else>--</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div style="border:1px solid #ebebeb;display: flex;padding: 2px 5px;" >
                <div style="width: 250px;border: 0px solid red;display: flex;align-items: center;">
                 共<span style="color: red;padding: 0 5px;">{{ data.TotalCount }}</span>条，总费用为：<span style="color: red;">￥{{ data.TotalAmount }}</span>
                </div>
                <div style="flex: 1;">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next"
                        :total="data.TotalCount">
                    </el-pagination>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {
    GetJobAdvanceFundsInfo,
} from "@/service/payApi";
export default {
    data() {
        return {
            detailsShow: false,
            loading: false,
            info: {},
            data: {
                TotalCount: 0,
                TotalAmount: 0
            },
            jobId: 0,
            pageNum: 1,
            pageSize: 1
        }
    },
    methods: {
        open(JobId) {
            this.detailsShow = true;
            this.jobId = JobId;
            this.GetJobAdvanceFundsInfoFun()
        },
        close() {
            this.detailsShow = false;
        },
        async GetJobAdvanceFundsInfoFun() {
            this.listLoading = true;
             this.info ={};
            let res = await GetJobAdvanceFundsInfo({ JobId: this.jobId, PageNum: this.pageNum, PageSize: this.pageSize })
            this.listLoading = false;
            if (res.Result != 1) {
                return this.$message.error(res.Message);
            }
            this.data = res.Data;
            setTimeout(()=>{
                this.info = res.Data.JobAdvanceFundsList && res.Data.JobAdvanceFundsList[0];
            },300)
            
        },
        handleSizeChange(val) {
            if (this.listLoading) return
            this.pageNum = 1;
            this.pageSize = val;
            this.GetJobAdvanceFundsInfoFun();
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.pageNum = val
            this.GetJobAdvanceFundsInfoFun();
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    padding-top: 0px;
}

/deep/.el-form-item--medium .el-form-item__content{
    line-height: 23px;
} 
 /deep/ .el-form-item--medium .el-form-item__label{
     line-height: 23px;
 }
 .yellow-tips {
    color: #e6a23c;  
}
</style>